import { AuthService } from '../auth/auth.service';
import { AbstractControl, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class ValidatorsService {

    user: any;

    constructor(private auth: AuthService) {
        this.auth.getUser.subscribe(data => {
            this.user = data;
        });
    }

    MatchPassword(AC: AbstractControl|any) {
        let password:any = AC.get('password').value;
        let confirmPassword:any = AC.get('confPassword').value;

        if (password != confirmPassword) {
            AC.get('confPassword').setErrors({ MatchPassword: true })
            return
        } else {
            return null;
        }
       
    }

    verifSameUsername(AC: AbstractControl): Object | null {
        let username = AC.value;
        let currUsername = this.user.displayName;

        if (currUsername && username) {
            if (currUsername.toLowerCase() === username.toLowerCase()) {
                return { "sameUsername": true };
            } else {
                return null;
            }
        } else {
            return null;
        }

    }

    noSpaceValidator(AC: AbstractControl) {
        let isValid = true;
        if (AC.value)
            isValid = AC.value.replace(/\s/g, '').length ? true : false;
        return isValid ? null : { 'nospace': true };
    }

}
